"use strict";

exports.__esModule = true;

var tslib_1 = require("tslib");

var Icon_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Icon"));

var Image_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Image"));

var Loader_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Loader"));

var Paginator_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Paginator"));

var Table_1 = require("@sportnet/ui/lib/Table");

var utilities_1 = require("@sportnet/ui/lib/Themes/utilities");

var utilities_2 = require("@sportnet/ui/lib/utilities");

var date_fns_1 = require("date-fns");

var moment_1 = tslib_1.__importDefault(require("moment"));

var polished_1 = require("polished");

var React = tslib_1.__importStar(require("react"));

var sportnet_utilities_1 = require("sportnet-utilities");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var CompetitionsApi_1 = tslib_1.__importDefault(require("../../../api/CompetitionsApi"));

var CoreApi_1 = tslib_1.__importDefault(require("../../../api/CoreApi"));

var setupApis_1 = require("../../../api/setupApis");

var _config_1 = tslib_1.__importDefault(require("../../../config"));

var _view_1 = tslib_1.__importDefault(require("../.."));

var MatchesList_1 = require("../MatchesList");

setupApis_1.setupCoreApi();
setupApis_1.setupCompetitionsApi();
var TopPanel = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"])));
var PlayerName = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  font-size: ", ";\n  font-weight: bold;\n"], ["\n  font-size: ", ";\n  font-weight: bold;\n"])), polished_1.rem(25));
var PersonDetail = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  ", " {\n    flex-direction: row;\n  }\n  justify-content: space-between;\n  padding-top: ", ";\n  & > div {\n    width: 100%;\n    text-align: center;\n    ", " {\n      width: 50%;\n      text-align: initial;\n    }\n  }\n  img {\n    width: ", ";\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  ", " {\n    flex-direction: row;\n  }\n  justify-content: space-between;\n  padding-top: ", ";\n  & > div {\n    width: 100%;\n    text-align: center;\n    ", " {\n      width: 50%;\n      text-align: initial;\n    }\n  }\n  img {\n    width: ", ";\n  }\n"])), utilities_1.mb('s'), polished_1.rem(20), utilities_1.mb('s'), polished_1.rem(200));
var Bio = styled_components_1["default"].div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  font-size: ", ";\n"], ["\n  font-size: ", ";\n"])), polished_1.rem(14));
var Wrapper = styled_components_1["default"].div(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  font-family: 'Roboto', sans-serif;\n"], ["\n  font-family: 'Roboto', sans-serif;\n"])));
var MATCHES_LIMIT = 10;

var C = function (props) {
  var id = props.id,
      appSpace = props.appSpace,
      handleClose = props.handleClose;

  var _a = React.useState(false),
      isFetching = _a[0],
      setIsFetching = _a[1];

  var _b = React.useState(null),
      organization = _b[0],
      setOrganization = _b[1];

  var _c = React.useState(null),
      user = _c[0],
      setUser = _c[1];

  var _d = React.useState(false),
      isFetchingMatches = _d[0],
      setIsFetchingMatches = _d[1];

  var _e = React.useState([]),
      matches = _e[0],
      setMatches = _e[1];

  var _f = React.useState(0),
      matchesOffset = _f[0],
      setMatchesOffset = _f[1];

  var _g = React.useState(0),
      matchesTotal = _g[0],
      setMatchesTotal = _g[1];

  var _h = React.useState([]),
      sportExpertCompetenceTypes = _h[0],
      setSportExpertCompetenceTypesItems = _h[1];

  var fetchData = function () {
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
      var ppo, userDetail, sportExpertCompetenceTypesItems, e_1;
      return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            setIsFetching(true);
            _a.label = 1;

          case 1:
            _a.trys.push([1, 5, 6, 7]);

            return [4
            /*yield*/
            , CoreApi_1["default"].organizationPPOProfile(appSpace)];

          case 2:
            ppo = _a.sent();
            return [4
            /*yield*/
            , CoreApi_1["default"].organizationPPOUser(appSpace, id, {
              withRelatedAffiliations: true
            })];

          case 3:
            userDetail = _a.sent();
            return [4
            /*yield*/
            , CoreApi_1["default"].getCodelist('sport-expert-competence-type')];

          case 4:
            sportExpertCompetenceTypesItems = _a.sent();
            setOrganization(ppo);
            setUser(userDetail);
            setSportExpertCompetenceTypesItems(sportExpertCompetenceTypesItems.codelist || []);
            getMatches();
            return [3
            /*break*/
            , 7];

          case 5:
            e_1 = _a.sent();
            alert(utilities_2.__('Nepodarilo sa získať podrobné údaje'));
            return [3
            /*break*/
            , 7];

          case 6:
            setIsFetching(false);
            return [7
            /*endfinally*/
            ];

          case 7:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  var getMatches = function (offset) {
    if (offset === void 0) {
      offset = 0;
    }

    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
      var resMatches, e_2;
      return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2, 3, 4]);

            setIsFetchingMatches(true);
            return [4
            /*yield*/
            , CompetitionsApi_1["default"].getPlayerMatches(appSpace, id, {
              offset: offset,
              limit: MATCHES_LIMIT
            })];

          case 1:
            resMatches = _a.sent();
            setMatches(resMatches.matches);
            setMatchesTotal(resMatches.total);
            setMatchesOffset(resMatches.offset);
            return [3
            /*break*/
            , 4];

          case 2:
            e_2 = _a.sent();
            alert(utilities_2.__('Nepodarilo sa získať zoznam zápasov zvolenej osoby.'));
            return [3
            /*break*/
            , 4];

          case 3:
            setIsFetchingMatches(false);
            return [7
            /*endfinally*/
            ];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  var getPhotoUrl = function () {
    if (sportnet_utilities_1.getProp(user || {}, ['bio', 0, 'photo', 'public_url'])) {
      return String(user.bio[0].photo.public_url);
    } else if (user && user.photo && user.photo.public) {
      return String(user.photo.public_url);
    } else if (organization) {
      return String(organization.logo_public_url);
    }

    return '';
  };

  React.useEffect(function () {
    fetchData();
  }, []);

  if (isFetching) {
    return React.createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }
    }, React.createElement(Loader_1["default"], {
      size: "xl"
    }));
  }

  var collectiveSportMatches = matches.filter(function (m) {
    return m.rules && ['futbal'].includes(m.rules.sport_sector);
  });

  var translateCompetenceType = function (value) {
    var item = sportExpertCompetenceTypes.find(function (i) {
      return i.value === value;
    });

    if (item) {
      return item.label;
    }

    return '';
  };

  return React.createElement(Wrapper, null, React.createElement(TopPanel, null, React.createElement(PlayerName, null, user && sportnet_utilities_1.formatUserName(user)), React.createElement("div", {
    style: {
      cursor: 'pointer'
    },
    onClick: function () {
      return handleClose();
    }
  }, React.createElement(Icon_1["default"], {
    name: "close",
    size: "xl"
  }))), React.createElement(PersonDetail, null, React.createElement("div", null, React.createElement(Image_1["default"], {
    src: getPhotoUrl()
  })), React.createElement("div", null, React.createElement(Table_1.Table, null, React.createElement(Table_1.Tbody, null, user && user.age && React.createElement(Table_1.Tr, null, React.createElement(Table_1.Td, null, React.createElement("b", null, utilities_2.__('Vek'))), React.createElement(Table_1.Td, null, user.age)), user && user.birthplace && React.createElement(Table_1.Tr, null, React.createElement(Table_1.Td, null, React.createElement("b", null, utilities_2.__('Miesto narodenia'))), React.createElement(Table_1.Td, null, user.birthplace)), user && user.deathdate && React.createElement(Table_1.Tr, null, React.createElement(Table_1.Td, null, React.createElement("b", null, utilities_2.__('Dátum úmrtia'))), React.createElement(Table_1.Td, null, moment_1["default"](user.deathdate).format('DD.MM.YYYY'))))))), React.createElement("br", null), React.createElement(Bio, null, user && user.bio && user.bio.map(function (i) {
    return React.createElement(_view_1["default"], {
      items: i.widgets
    });
  })), React.createElement("br", null), React.createElement(Table_1.Table, null, React.createElement(Table_1.Tbody, null, user && user.regnrs && user.regnrs.length > 0 && React.createElement(Table_1.Tr, null, React.createElement(Table_1.Td, null, React.createElement("b", null, utilities_2.__('Registračné číslo'))), React.createElement(Table_1.Td, null, user.regnrs.map(function (i) {
    return React.createElement(React.Fragment, null, i.regnr, React.createElement("br", null));
  }))), user && user.membership && user.membership.length > 0 && React.createElement(Table_1.Tr, null, React.createElement(Table_1.Td, null, React.createElement("b", null, utilities_2.__('Členstvá'))), React.createElement(Table_1.Td, null, user.membership.map(function (i, idx) {
    return React.createElement(React.Fragment, null, i.org_profile_name, i.valid_from && React.createElement(React.Fragment, null, React.createElement("br", null), utilities_2.__('od'), ":", ' ', date_fns_1.format(new Date(i.valid_from), _config_1["default"].DEFAULT_DATE_FORMAT)), i.valid_to && React.createElement(React.Fragment, null, React.createElement("br", null), utilities_2.__('do'), ":", ' ', date_fns_1.format(new Date(i.valid_to), _config_1["default"].DEFAULT_DATE_FORMAT)), idx + 1 !== user.membership.length && React.createElement(React.Fragment, null, React.createElement("br", null), React.createElement("br", null)));
  }))), user && user.sport_expert_licenses && user.sport_expert_licenses.length > 0 && React.createElement(Table_1.Tr, null, React.createElement(Table_1.Td, null, React.createElement("b", null, utilities_2.__('Kvalifikácie / licencie'))), React.createElement(Table_1.Td, null, user.sport_expert_licenses.map(function (i, idx) {
    return React.createElement(React.Fragment, null, i.name, i.documentnr && React.createElement(React.Fragment, null, React.createElement("br", null), utilities_2.__('č. dokumentu'), ": ", i.documentnr), i.valid_from && React.createElement(React.Fragment, null, React.createElement("br", null), utilities_2.__('od'), ":", ' ', date_fns_1.format(new Date(i.valid_from), _config_1["default"].DEFAULT_DATE_FORMAT)), i.valid_to && React.createElement(React.Fragment, null, React.createElement("br", null), utilities_2.__('do'), ":", ' ', date_fns_1.format(new Date(i.valid_to), _config_1["default"].DEFAULT_DATE_FORMAT)), idx + 1 !== user.sport_expert_licenses.length && React.createElement(React.Fragment, null, React.createElement("br", null), React.createElement("br", null)));
  }))), user && user.sport_orgs && user.sport_orgs.length > 0 && React.createElement(React.Fragment, null, user.sport_orgs.map(function (i, idx) {
    return React.createElement(React.Fragment, null, React.createElement(Table_1.Tr, null, React.createElement(Table_1.Td, null, React.createElement("b", null, utilities_2.__('Športovec'))), React.createElement(Table_1.Td, null, i.org_profile_name, i.date_from && React.createElement(React.Fragment, null, React.createElement("br", null), utilities_2.__('od'), ":", ' ', date_fns_1.format(new Date(i.date_from), _config_1["default"].DEFAULT_DATE_FORMAT)), i.date_to && React.createElement(React.Fragment, null, React.createElement("br", null), utilities_2.__('do'), ":", ' ', date_fns_1.format(new Date(i.date_to), _config_1["default"].DEFAULT_DATE_FORMAT)))));
  })), user && user.sport_expert_orgs && user.sport_expert_orgs.length > 0 && React.createElement(React.Fragment, null, user.sport_expert_orgs.map(function (i, idx) {
    return React.createElement(React.Fragment, null, React.createElement(Table_1.Tr, null, React.createElement(Table_1.Td, null, React.createElement("b", null, translateCompetenceType(i.competence_type))), React.createElement(Table_1.Td, null, i.org_profile_name, React.createElement("br", null), utilities_2.__('od'), ":", ' ', date_fns_1.format(new Date(i.date_from), _config_1["default"].DEFAULT_DATE_FORMAT), i.date_to && React.createElement(React.Fragment, null, React.createElement("br", null), utilities_2.__('do'), ":", ' ', date_fns_1.format(new Date(i.date_to), _config_1["default"].DEFAULT_DATE_FORMAT)))));
  })))), collectiveSportMatches.length > 0 && React.createElement("div", {
    style: {
      paddingTop: polished_1.rem(16)
    }
  }, React.createElement(Table_1.Table, null, React.createElement(Table_1.Thead, null, React.createElement(Table_1.Tr, null, React.createElement(Table_1.Th, null, utilities_2.__('Dátum')), React.createElement(Table_1.Th, null, utilities_2.__('Domáci / Hostia')), React.createElement(Table_1.Th, null, utilities_2.__('Súper')), React.createElement(Table_1.Th, null, utilities_2.__('Výsledok')), React.createElement(Table_1.Th, null, utilities_2.__('Góly')), React.createElement(Table_1.Th, null, utilities_2.__('ŽK')), React.createElement(Table_1.Th, null, utilities_2.__('ČK')))), React.createElement(Table_1.Tbody, null, collectiveSportMatches.map(function (i) {
    var opponent = i.teams.find(function (t) {
      return t.appSpace !== appSpace;
    });

    var _a = MatchesList_1.getGoalsByTeams(i),
        homeTeamGoals = _a.homeTeamGoals,
        awayTeamGoals = _a.awayTeamGoals;

    var playerGoals = sportnet_utilities_1.getProp(i, ['protocol', 'events'], []).filter(function (e) {
      return e.player._id === user._id && e.eventType === 'goal' && e.phase !== 'shootout' && e.type !== 'dropped';
    });
    var playerYellowCards = sportnet_utilities_1.getProp(i, ['protocol', 'events'], []).filter(function (e) {
      return e.player._id === user._id && e.eventType === 'yellow_card';
    });
    var playerRedCards = sportnet_utilities_1.getProp(i, ['protocol', 'events'], []).filter(function (e) {
      return e.player._id === user._id && e.eventType === 'red_card';
    });
    return React.createElement(Table_1.Tr, null, React.createElement(Table_1.Td, null, moment_1["default"](i.startDate).format('DD.MM.YYYY')), React.createElement(Table_1.Td, null, opponent && opponent.additionalProperties && opponent.additionalProperties.homeaway === 'home' ? utilities_2.__('Hostia') : utilities_2.__('Domáci')), React.createElement(Table_1.Td, null, opponent && opponent.displayName), React.createElement(Table_1.Td, null, homeTeamGoals + ":" + awayTeamGoals), React.createElement(Table_1.Td, null, playerGoals.length), React.createElement(Table_1.Td, null, playerYellowCards.length), React.createElement(Table_1.Td, null, playerRedCards.length));
  }))), React.createElement("div", null, React.createElement(Paginator_1["default"], {
    limit: MATCHES_LIMIT,
    total: matchesTotal,
    offset: matchesOffset,
    onChangeOffset: getMatches,
    loading: isFetchingMatches
  }))));
};

exports["default"] = C;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;